import React from 'react';
import { WarningPanel } from '@backstage/core-components';

function MissingResources() {
  return /* @__PURE__ */ React.createElement(
    WarningPanel,
    {
      title: "No matching resources found.",
      message: /* @__PURE__ */ React.createElement(React.Fragment, null, "No AWS resources could be found that match the annotations provided.")
    }
  );
}

export { MissingResources };
//# sourceMappingURL=MissingResources.esm.js.map
